import { createSelector } from 'reselect'
import { BUSINESS_TRAVELLER_APPROVER_ROLES } from 'businessTraveller/constants/businessTravellerEmployeeRoleConstants'

export const isBusinessTravellerTripRequestApprover = createSelector(
  (state: App.State) => state.businessTraveller.currentBusinessAccount?.employee?.roles,
  (roles) => roles?.some(role => BUSINESS_TRAVELLER_APPROVER_ROLES.includes(role)),
)
